var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "24px",
    width: "24px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 442 442",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,327.295H59.468V49.539C59.468,22.224,37.277,0,10,0C4.477,0,0,4.478,0,10s4.477,10,10,10 c16.249,0,29.468,13.251,29.468,29.539v287.756c0,5.522,4.477,10,10,10H432c5.523,0,10-4.478,10-10S437.523,327.295,432,327.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.468,307.241H392c5.523,0,10-4.478,10-10v-82.603c0-5.522-4.477-10-10-10H89.468c-5.523,0-10,4.478-10,10v82.603 C79.468,302.764,83.945,307.241,89.468,307.241z M316.111,287.241v-21.302H382v21.302H316.111z M382,245.939h-65.889v-21.301H382 V245.939z M99.468,224.639h196.644v62.603H99.468V224.639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.468,184.584H392c5.523,0,10-4.478,10-10V91.981c0-5.522-4.477-10-10-10H89.468c-5.523,0-10,4.478-10,10v82.603 C79.468,180.106,83.945,184.584,89.468,184.584z M316.111,164.584v-21.301H382v21.301H316.111z M382,123.283h-65.889v-21.302H382 V123.283z M99.468,101.981h196.644v62.603H99.468V101.981z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.898,357.619c-23.264,0-42.19,18.927-42.19,42.19S78.634,442,101.898,442s42.19-18.927,42.19-42.19 S125.162,357.619,101.898,357.619z M101.898,422c-12.236,0-22.19-9.955-22.19-22.19s9.955-22.19,22.19-22.19 s22.19,9.955,22.19,22.19S114.134,422,101.898,422z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,357.619c-23.264,0-42.19,18.927-42.19,42.19S356.306,442,379.57,442s42.19-18.927,42.19-42.19 S402.833,357.619,379.57,357.619z M379.57,422c-12.236,0-22.19-9.955-22.19-22.19s9.955-22.19,22.19-22.19s22.19,9.955,22.19,22.19 S391.806,422,379.57,422z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.021d16084998cb9a8bb4e746efd2c2ba.svg";
export { ForwardRef as ReactComponent };